import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import Pagination from "react-js-pagination";
import { LichSuGiaHanKy } from "./LichSuGiaHanKy";
import DanhSachTaiSanApi from "service/danhSachTaiSanApi";
import { currentDate } from "utils/formatDate";
import { useDispatch, useSelector } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import { pushNotification } from "utils/notifications";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";

export const ModalGiaHan = (props) => {
  //Code
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  // console.log(user.combo);
  const initData = {
    TaiSanID: "",
    GiaHanDenNgay: currentDate(),
    LyDo: "",
    GhiChu: "",
    Code: "",
  };

  const [dataGiaHan, setDataGiaHan] = useState(initData);

  const initLichSu = {
    taiSanId: props.TaiSanID,
    pageSize: 5,
    pageIndex: 1,
    totalRow: 0,
  };
  const [LichSuTaiSan, setLichSuTaiSan] = useState(initLichSu);
  const [listLichSuTaiSan, setListLichSuTaiSan] = useState();

  const DanhSachLichSu = () => {
    DanhSachTaiSanApi.getLichSuGiaHan(
      LichSuTaiSan.taiSanId,
      LichSuTaiSan.pageSize,
      LichSuTaiSan.pageIndex
    ).then((response) => {
      setListLichSuTaiSan(response.data.List);
    });
  };

  const updateDropdown = (field) => (e) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: e.target.value,
    });
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: e.target.value,
    });
  };
  const onChangeNumber = (field) => (evt) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: convertToNumber(evt.target.value),
    });
  };

  const onChangeDate = (field) => (evt) => {
    setDataGiaHan({
      ...dataGiaHan,
      [field]: formatDayMonth(evt),
    });
    if (evt <= currentDate()) {
      setErrors({
        ...errors,
        giaHanDenNgay: "Ngày gia hạn phải lớn hơn ngày hiện tại",
      });
    } else {
      setErrors({
        ...errors,
        giaHanDenNgay: "",
      });
    }
  };

  useEffect(() => {
    DanhSachTaiSanApi.getOneDetailTaiSan(props.TaiSanID).then((response) => {
      // alert(response.data.ThongTinTaiSan.Code);
      setDataGiaHan({
        ...dataGiaHan,
        Code: response.data.ThongTinTaiSan.Code,
        TaiSanID: response.data.ThongTinTaiSan.TaiSanId,
      });
    });
    DanhSachLichSu();
  }, []);

  //Thông báo
  const initErrors = {
    giaHanDenNgay: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const onSubmit = () => {
    if (dataGiaHan.GiaHanDenNgay <= currentDate()) {
      setErrors({
        ...errors,
        giaHanDenNgay: "Ngày gia hạn phải lớn hơn ngày hiện tại",
      });
      return;
    } else {
      DanhSachTaiSanApi.giaHan(
        dataGiaHan.TaiSanID,
        dataGiaHan.GiaHanDenNgay,
        dataGiaHan.LyDo,
        dataGiaHan.GhiChu
      ).then((response) => {
        pushNotification("Gia hạn thành công.", "success", "TOP_CENTER", 1000);
        props.onHide();
        dispatch(getListTaiSan(dataSearch));
      });
    }
  };

  const handlePageChange = (pageNumber) => {
    LichSuTaiSan.pageIndex = pageNumber;
    LichSuTaiSan.pageSize = 1;
    DanhSachLichSu();
  };

  const TotalQuantity = LichSuTaiSan.totalRow;

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/logo-gia-han-v2.png" />
          </span>{" "}
          Gia hạn
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse5311"
                className="card-header"
                href="#collapse5311"
                aria-expanded="true"
                aria-controls="collapse5311"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Gia hạn tài sản</h3>
                </a>
              </div>
              <div
                id="collapse5311"
                aria-labelledby="headingCollapse5311"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className="color7-bold">
                                Gia hạn đến ngày
                              </label>
                              <DateTimePicker
                                value={convertDate(dataGiaHan.GiaHanDenNgay)}
                                name="GiaHanDenNgay"
                                onChange={onChangeDate("GiaHanDenNgay")}
                                // customInputRef={NgayThanhToan}
                              ></DateTimePicker>
                              {errors.giaHanDenNgay && (
                                <span className="canh-bao-red">
                                  {errors.giaHanDenNgay}
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-md-4">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Mã tài sản"
                              value={dataGiaHan.Code}
                              disabled="disabled"
                            ></TextInputOnRow>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label
                                for="projectinput2"
                                className="color7-bold"
                              >
                                Lý do gia hạn
                              </label>
                              <textarea
                                id="projectinput8"
                                rows="1"
                                className="form-control input-sm  text-era"
                                name="LyDo"
                                placeholder=""
                                value={dataGiaHan.LyDo}
                                onChange={updateTextValue("LyDo")}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label for="projectinput8 color7-bold">
                                Ghi chú
                              </label>
                              <textarea
                                id="projectinput8"
                                rows="1"
                                className="form-control input-sm"
                                name="GhiChu"
                                placeholder=""
                                value={dataGiaHan.GhiChu}
                                onChange={updateTextValue("GhiChu")}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="headingCollapse19167"
                className="card-header mt-1"
                href="#collapse19167"
                aria-expanded="true"
                aria-controls="collapse19167"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Lịch sử gia hạn</h3>
                </a>
              </div>
              <div
                id="collapse19167"
                aria-labelledby="headingCollapse19167"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <LichSuGiaHanKy listLichSuTaiSan={listLichSuTaiSan} />

                    <div
                      className={
                        "paniation-new paniation-new1 d-flex justify-content-center mt-1 " +
                        (TotalQuantity === 0 ? "hidden" : "")
                      }
                    >
                      <nav aria-label="Page navigation">
                        <Pagination
                          activePage={LichSuTaiSan.pageIndex}
                          itemsCountPerPage={LichSuTaiSan.pageSize}
                          totalItemsCount={TotalQuantity}
                          pageRangeDisplayed={5}
                          onChange={handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          activeClass="active"
                        />
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>

        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSubmit}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>
          &nbsp; Cập nhật &nbsp;
        </a>
      </Modal.Footer>
    </Modal>
  );
};
